import axios from "axios";

// GDPR S7.3b-2 — client for the Privacy-manager preference-link recovery API (`/ncrm/privacy/preference-links`).
// Token ids are BIGINT and stay strings end to end; the one-time URL is never stored or logged here.
export const PREFERENCE_LINKS_ENDPOINT = "/ncrm/privacy/preference-links";
export const PREFERENCE_LINK_LOCALES = Object.freeze([
  { value: "ro", title: "Română" }, { value: "en", title: "English" }, { value: "ru", title: "Русский" },
]);

export const listPreferencePoints = async ({ subjectType, subjectId }) =>
  (await axios.get(`${PREFERENCE_LINKS_ENDPOINT}/points`, { params: { subject_type: subjectType, subject_id: subjectId } }))
    .data?.items || [];

export const listPreferenceLinks = async ({ contactPointId, before = null }) => {
  const params = { contact_point_id: contactPointId, ...(before ? { before } : {}) };
  const { data } = await axios.get(PREFERENCE_LINKS_ENDPOINT, { params });
  return { items: data?.items || [], nextCursor: data?.nextCursor || null };
};

export const issuePreferenceLink = async ({ contactPointId, locale }) =>
  (await axios.post(PREFERENCE_LINKS_ENDPOINT, { contact_point_id: contactPointId, locale })).data;

export const revokePreferenceLink = async (id) =>
  (await axios.delete(`${PREFERENCE_LINKS_ENDPOINT}/${encodeURIComponent(String(id))}`)).data;

// UI date format is fixed dd.mm.yyyy (docs/design.md), read from the UTC timestamp, independent of browser locale.
export const formatLinkDate = (iso) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})T/.exec(String(iso || ""));
  return match ? `${match[3]}.${match[2]}.${match[1]}` : "";
};

// The server's `active` (computed with the backend clock) wins, so a skewed workstation clock never hides Revoke.
export const linkStatus = (link, now = new Date()) => {
  if (link?.revokedAt) return "revoked";
  if (typeof link?.active === "boolean") return link.active ? "active" : "expired";
  return Date.parse(link?.expiresAt) > now.getTime() ? "active" : "expired";
};

export const LINK_STATUS_COLORS = Object.freeze({ active: "success", revoked: "secondary", expired: "warning" });
